import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/helpers/i18n';
import { isAdmin, isCoach } from "@/helpers/utils.js";

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Login = () => import('@/views/Login')
const Page404 = () => import('@/views/Page404');
const Page500 = () => import('@/views/Page500');
const ConfirmAccount = () => import('@/views/ConfirmAccount')
const Profile = () => import('@/views/Profile')

// Views - Pages
const CoachingSessionsList = () => import('@/views/CoachingSessions/CoachingSessionsList')
const CoachingSessionAdd = () => import('@/views/CoachingSessions/CoachingSessionAdd')
const CoachingSessionEdit = () => import('@/views/CoachingSessions/CoachingSessionEdit')
const HerosList = () => import('@/views/Heros/HerosList')
const HeroAdd = () => import('@/views/Heros/HeroAdd')
const HeroEdit = () => import('@/views/Heros/HeroEdit')
const KeyValuesList = () => import('@/views/KeyValues/KeyValuesList')
const KeyValueAdd = () => import('@/views/KeyValues/KeyValueAdd')
const KeyValueEdit = () => import('@/views/KeyValues/KeyValueEdit')
const StaticInfosList = () => import('@/views/StaticInfos/StaticInfosList')
const StaticInfoAdd = () => import('@/views/StaticInfos/StaticInfoAdd')
const StaticInfoEdit = () => import('@/views/StaticInfos/StaticInfoEdit')
const UsersList = () => import('@/views/Users/UsersList')
const UserAdd = () => import('@/views/Users/UserAdd')
const UserEdit = () => import('@/views/Users/UserEdit')
const BoardsList = () => import('@/views/Boards/BoardsList')
const BoardAdd = () => import('@/views/Boards/BoardAdd')
const BoardEdit = () => import('@/views/Boards/BoardEdit')
const CharactersList = () => import('@/views/Characters/CharactersList')
const CharacterAdd = () => import('@/views/Characters/CharacterAdd')
const CharacterEdit = () => import('@/views/Characters/CharacterEdit')
const VariationsList = () => import('@/views/Variations/VariationsList')
const VariationAdd = () => import('@/views/Variations/VariationAdd')
const VariationEdit = () => import('@/views/Variations/VariationEdit')
const GroupsList = () => import('@/views/Groups/GroupsList')
const GroupAdd = () => import('@/views/Groups/GroupAdd')
const GroupEdit = () => import('@/views/Groups/GroupEdit')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: () => {
        if (isAdmin()) {
          return '/' + i18n.t('users');
        } else if (isCoach()) {
          return '/' + i18n.t('coachingSessions');
        } else {
          return '/' + i18n.t('login');
        }
      },
      name: 'Home',
      component: TheContainer,
      children: [
          {
          path: i18n.t('coachingSessions'),
          redirect: '/' + i18n.t('coachingSessions') + '/' + i18n.t('list'),
          name: 'CoachingSessions',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'CoachingSessionsList',
              component: CoachingSessionsList
            },
            {
              path: i18n.t('add'),
              name: 'CoachingSessionAdd',
              component: CoachingSessionAdd
            },
            {
              path: i18n.t('edit'),
              name: 'CoachingSessionEdit',
              component: CoachingSessionEdit
            },
          ]
        },
        {
          path: i18n.t('heros'),
          redirect: '/' + i18n.t('heros') + '/' + i18n.t('list'),
          name: 'Heros',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'HerosList',
              component: HerosList
            },
            {
              path: i18n.t('add'),
              name: 'HeroAdd',
              component: HeroAdd
            },
            {
              path: i18n.t('edit'),
              name: 'HeroEdit',
              component: HeroEdit
            },
          ]
        },
        {
          path: i18n.t('keyValues'),
          redirect: '/' + i18n.t('keyValues') + '/' + i18n.t('list'),
          name: 'KeyValues',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'KeyValuesList',
              component: KeyValuesList
            },
            {
              path: i18n.t('add'),
              name: 'KeyValueAdd',
              component: KeyValueAdd
            },
            {
              path: i18n.t('edit'),
              name: 'KeyValueEdit',
              component: KeyValueEdit
            },
          ]
        },
        {
          path: i18n.t('staticInfos'),
          redirect: '/' + i18n.t('staticInfos') + '/' + i18n.t('list'),
          name: 'StaticInfos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'StaticInfosList',
              component: StaticInfosList
            },
            {
              path: i18n.t('add'),
              name: 'StaticInfoAdd',
              component: StaticInfoAdd
            },
            {
              path: i18n.t('edit'),
              name: 'StaticInfoEdit',
              component: StaticInfoEdit
            },
          ]
        },
        {
          path: i18n.t('users'),
          redirect: '/' + i18n.t('users') + '/' + i18n.t('list'),
          name: 'Users',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'UsersList',
              component: UsersList
            },
            {
              path: i18n.t('add'),
              name: 'UserAdd',
              component: UserAdd
            },
            {
              path: i18n.t('edit'),
              name: 'UserEdit',
              component: UserEdit
            },
          ]
        },
        {
          path: i18n.t('boards'),
          redirect: '/' + i18n.t('boards') + '/' + i18n.t('list'),
          name: 'Boards',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'BoardsList',
              component: BoardsList
            },
            {
              path: i18n.t('add'),
              name: 'BoardAdd',
              component: BoardAdd
            },
            {
              path: i18n.t('edit'),
              name: 'BoardEdit',
              component: BoardEdit
            },
          ]
        },
        {
          path: i18n.t('characters'),
          redirect: '/' + i18n.t('characters') + '/' + i18n.t('list'),
          name: 'Characters',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'CharactersList',
              component: CharactersList
            },
            {
              path: i18n.t('add'),
              name: 'CharacterAdd',
              component: CharacterAdd
            },
            {
              path: i18n.t('edit'),
              name: 'CharacterEdit',
              component: CharacterEdit
            },
          ]
        },
        {
          path: i18n.t('variations'),
          redirect: '/' + i18n.t('variations') + '/' + i18n.t('list'),
          name: 'Variations',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'VariationsList',
              component: VariationsList
            },
            {
              path: i18n.t('add'),
              name: 'VariationAdd',
              component: VariationAdd
            },
            {
              path: i18n.t('edit'),
              name: 'VariationEdit',
              component: VariationEdit
            },
          ]
        },
        {
            path: i18n.t('groups'),
            redirect: '/' + i18n.t('groups') + '/' + i18n.t('list'),
            name: 'Groups',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: i18n.t('list'),
                name: 'GroupsList',
                component: GroupsList
              },
              {
                path: i18n.t('add'),
                name: 'GroupAdd',
                component: GroupAdd
              },
              {
                path: i18n.t('edit'),
                name: 'GroupEdit',
                component: GroupEdit
              },
            ]
          },
          {
            path: i18n.t('profile'),
            name: 'Profile',
            component: Profile
          },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/confirm-account',
      name: 'ConfirmAccount',
      component: ConfirmAccount
    },
    {
      path: '/404',
      name: '404',
      component: Page404
    },    
    {
      path: '/500',
      name: '500',
      component: Page500
    }, 
  ]
}

